<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="门店管理" name="first">

      </el-tab-pane>
      <el-tab-pane label="账号管理" name="second">
        <div>

        </div>
      </el-tab-pane>
      <el-tab-pane label="角色权限" name="three">
        <div>
          <div>
            <div>
              <!-- <el-button class="creat-button" type="primary" size="small" @click="creatdjDialogVisible = true">新建角色
              </el-button> -->
            </div>
            <div class="mm-tb">
              <el-table
                :data="jsList"
                style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="roleName"
                  label="角色名称"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="description"
                  label="角色描述"
                  align="center"
                >
                </el-table-column>

                <el-table-column
                  label="操作"
                  align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="medium" @click="zhEdit(scope.row)">编辑</el-button>
                    <el-button type="text" size="medium" @click="changePwd(scope.row.userId)">查看</el-button>
                    <el-button type="text" size="medium" @click="deletZh(scope.row.userId)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                class="mm-page"
                @size-change="jsSizeChange"
                @current-change="jsCurrentChange"
                :current-page="jsResult.current"
                :page-size="jsResult.size"
                layout="total,prev, pager, next, sizes"
                :total="jsResult.total"
                :page-sizes="[10, 20, 30, 40, 50]"
                >

              </el-pagination>
            </div>
            <el-dialog
              title="新建会员卡"
              :visible.sync="creatdjDialogVisible"
              :close-on-click-modal="false"
              width="45%">
              <div class="creat_div">
                <span class="label_class">角色名称</span>
                <Input v-model="role.roleName" placeholder="输入角色名称" style="width:418px;"
                       :readonly="$route.query.type=='look'"/>
              </div>
              <div class="creat_div">
                <span class="label_class">角色描述</span>
                <textarea v-model="role.description" class="text_class" placeholder="输入角色描述"
                          :readonly="$route.query.type=='look'"></textarea>
              </div>
              <div>
                <span class="label_class">权限</span>
                <div class='left_div'>
                  <ul>
                    <li v-for="(item,i) in newlist" :key='i' style="margin-bottom:20px;">
                      <div style="margin-bottom:15px;">
                            <span class="quare" @click="$route.query.type=='look'?'':(item.choose=!item.choose)"
                                  style="white-space:nowrap;">
                                <span style="display:inline-block;width:3px;"></span><img src="@/assets/img/choose.png"
                                                                                          alt=""
                                                                                          :class="item.choose?'':'hidden'">
                            </span>
                        <span style="color: #101d37;font-weight:700;cursor: pointer;"
                              @click="$route.query.type=='look'?'':(item.choose=!item.choose)">
                                {{item.componentName}}
                            </span>
                      </div>
                      <div>
                        <div v-for="(child,index) in item.children" :key='index'
                             style="display:inline-block;margin-bottom:15px;">

                                <span class="quare" @click="$route.query.type=='look'?'':(child.choose=!child.choose)"
                                      style="white-space:nowrap;">
                                    <span style="display:inline-block;width:3px;"></span><img
                                  src="@/assets/img/choose.png" alt="" :class="child.choose?'':'hidden'">
                                </span>
                          <span style="min-width:130px;display:inline-block;color: #101d37;cursor: pointer;"
                                @click="$route.query.type=='look'?'':(child.choose=!child.choose)">
                                    {{child.componentName}}
                                </span>
                        </div>

                      </div>
                    </li>
                  </ul>
                  <button class="btn_class submit" @click="submit" v-if="$route.query.type!=='look'">保存</button>
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
              <el-button @click="creatmdDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="createzhCommit">确 定</el-button>
            </span>
            </el-dialog>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="会员等级" name="four">

      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import {
    getRoleList
  } from '../../api/BusinessManagement.js'
  import {admin} from '@/api/admin'
  import {menulist} from '@/api/axios'
  import {globelurl, posturl} from "../../api/axios.js";

  export default {
    name: "MembershipLevel",
    data() {
      return {
        activeName: 'three',
        upLoadUrl: posturl,
        headers: {'X-Access-Token': sessionStorage.token},
        jsParams: {
          pageNo: 1,
          pageSize: 10,
        },
        jsResult: {},
        jsList: [],
        LevelSelectList: [],
        newCard: {
          arrowVolume: 0,
          cardName: "",
          electronicCard: 0,
          electronicCardDays: 0,
          equitiesList: [
            {
              id: "",
              level: 0,
              levelId: "",
              name: "",
              pointEnd: 0,
              pointStart: 0,
              price: 0
            }
          ],
          followPrice: 0,
          id: "",
          level: 0,
          upgradePrice: 0
        },
        specisLabeList: [{specisLabel: ''}], //添加特色标签
        creatdjDialogVisible: false,
        role: {
          roleName: "",
          description: "",
        },
        qxlist: [],
        defaultid: [],
      }
    },
    computed: {
      newlist() {
        let arr = [];
        if (this.qxlist.length == 0) {
          return [];
        }
        for (var i = 0; i < this.qxlist.length; i++) {
          arr[i] = {};
          this.$set(this.qxlist[i], 'choose', false);
          // this.qxlist[i].choose=false;
          arr[i] = this.qxlist[i];
          if (this.qxlist[i].isLeaf == '0') {
            for (var j = 0; j < this.qxlist[i].children.length; j++) {
              this.$set(this.qxlist[i].children[j], 'choose', false);

              if (this.qxlist[i].children[j].isLeaf == '0') {
                for (var k = 0; k < this.qxlist[i].children[j].children.length; k++) {
                  this.$set(this.qxlist[i].children[j].children[k], 'choose', false);
                  // this.qxlist[i].children[j].children[k].choose=false;
                }
                arr[i].children = [...arr[i].children, ...arr[i].children[j].children];
              }
            }
          }
        }
        for (var m = 0; m < this.defaultid.length; m++) {
          for (var k = 0; k < arr.length; k++) {
            if (this.defaultid[m] == arr[k].permissionId) {
              this.$set(arr[k], 'choose', true);
            }
            if (arr[k].isLeaf == '0') {
              for (var j = 0; j < arr[k].children.length; j++) {
                if (this.defaultid[m] == arr[k].children[j].permissionId) {
                  this.$set(arr[k].children[j], 'choose', true);
                }
              }
            }
          }

        }
        return arr;
      }
    },
    mounted() {
      this.getRoleList(this.jsParams)
      this.getqxlist();
    },
    methods: {
      //tab栏切换
      handleClick(tab, event) {
        if (tab.label == '门店管理') {
          this.$router.push('/BusinessManagement/StoreManagement');
        } else if (tab.label == '账号管理') {
          this.$router.push('/BusinessManagement/NumberManagement');
        } else if (tab.label == '角色权限') {

        } else if (tab.label == '会员等级') {
          this.$router.push('/BusinessManagement/MembershipLevel');
        }
      },
      //角色管理页码跳转
      jsSizeChange(newSize) {
        this.jsParams.pageSize = newSize
        this.getMembersLevelPage(this.jsParams)
      },
      //角色管理页码跳转
      jsCurrentChange(newPage) {
        this.jsParams.pageNo = newPage
        this.getMembersLevelPage(this.jsParams)
      },
      //查询会员卡等级
      getRoleList(params) {
        getRoleList(params).then(res => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: '查无数据'
              })
            } else {
              this.jsResult = res.data.result
              this.jsList = res.data.result.records
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
      },
      //获取会员等级下拉列表
      getMembersCardLevelSelect() {
        getMembersCardLevelSelect().then(res => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: '查无数据'
              })
            } else {
              // this.mdSelectList = res.data.result
            }
          }
        })
      },
      getqxlist() {
        menulist().then(res => {
          if (res.data.success == true) {
            this.qxlist = res.data.result;
          }
        })
      },
      getinfor() {
        admin.getroleInfor(this.$route.query.id).then(res => {
          if (res.data.success == true) {
            this.role.roleName = res.data.result.role.roleName;
            this.role.roleId = res.data.result.role.roleId;
            this.role.description = res.data.result.role.description;
            this.defaultid = res.data.result.permissionIds;
            this.getqxlist();
          }
        })
      },
      submit() {
        if (!this.btnclick) {
          this.$Message.error('已提交，请稍候');
          return;
        }
        this.permissionIds = [];
        for (var i = 0; i < this.newlist.length; i++) {
          if (this.newlist[i].choose == true) {
            this.permissionIds.push(this.newlist[i].permissionId);
          }
          if (this.newlist[i].isLeaf == '0') {
            for (var j = 0; j < this.newlist[i].children.length; j++) {
              if (this.newlist[i].children[j].choose == true) {
                this.permissionIds.push(this.newlist[i].children[j].permissionId);
              }
            }
          }
        }
        if (!this.role.roleName) {
          this.$Message.error('请填写用户角色');
          return;
        }
        if (this.role.roleName.length > 20) {
          this.$Message.error('角色不能超过20个字');
          return;
        }
        if (!this.role.description) {
          this.$Message.error('请填写用户角色描述');
          return;
        }
        if (this.role.description.length > 100) {
          this.$Message.error('角色描述不能超过100个字');
          return;
        }
        if (this.permissionIds.length == 0) {
          this.$Message.error('请选择权限');
          return;
        }
        this.btnclick = false;
        if (this.$route.query.id) {
          admin.editrole(this.role, this.permissionIds).then(res => {
            this.btnclick = true;
            if (res.data.success == true) {

              this.$router.go(-1);
            } else {
              this.$Message.error(res.data.message);
            }
          });
        } else {
          this.role.roleCode = 'custom';
          admin.addrole(this.role, this.permissionIds).then(res => {
            this.btnclick = true;
            if (res.data.success == true) {

              this.$router.go(-1);
            } else {
              this.$Message.error(res.data.message);
            }
          });
        }

      },


      //新建账号提交
      createzhCommit() {
        // console.log(this.newCard)
        var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
        if (!phonereg.test(this.newCard.phone)) {
          this.$message.error('请输入正确联系电话');
        } else if (this.newCard.userName == '') {
          this.$message.error('请输入账号');
        } else if (this.newCard.realName == '') {
          this.$message.error('请输入姓名');
        } else if (this.newCard.password == '') {
          this.$message.error('请输入密码');
        } else if (this.newCard.phone == '') {
          this.$message.error('请输入联系电话');
        } else if (this.newCard.shopId == '') {
          this.$message.error('请选择部门');
        } else if (this.newCard.roleId == '') {
          this.$message.error('请选择角色');
        } else {
          addUser(this.newCard).then(res => {
            if (res.status === 200 && res.data.success) {
              if (res.data.result.total === 0) {
                this.$Notice.open({
                  title: '查无数据'
                })
              } else {
                this.$message.success('新建账号成功');
                this.creatzhDialogVisible = false
                this.getCountList(this.zhParams)
              }
            } else {
              this.$message.error(res.data.message);
            }
          })
        }
      },
      //获取账号信息
      zhEdit(val) {
        console.log(val)
        getUserById({'userId': val.userId}).then(res => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: '查无数据'
              })
            } else {
              this.editzhDialogVisible = true
              this.zhEditParams.userName = res.data.result.userName
              this.zhEditParams.userId = res.data.result.userId
              this.zhEditParams.realname = res.data.result.realname
              this.zhEditParams.phone = res.data.result.phone
              this.zhEditParams.shopId = res.data.result.shopId
              this.zhEditParams.roleId = res.data.result.roleId
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
      },
      //编辑账号提交
      editzhCommit() {
        // console.log(this.zhCreatParams)
        var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
        if (!phonereg.test(this.zhEditParams.phone)) {
          this.$message.error('请输入正确联系电话');
        } else if (this.zhEditParams.userName == '') {
          this.$message.error('请输入账号');
        } else if (this.zhEditParams.realName == '') {
          this.$message.error('请输入姓名');
        } else if (this.zhEditParams.phone == '') {
          this.$message.error('请输入联系电话');
        } else if (this.zhEditParams.shopId == '') {
          this.$message.error('请选择部门');
        } else if (this.zhEditParams.roleId == '') {
          this.$message.error('请选择角色');
        } else {
          updateUser(this.zhEditParams).then(res => {
            if (res.status === 200 && res.data.success) {
              if (res.data.result.total === 0) {
                this.$Notice.open({
                  title: '查无数据'
                })
              } else {
                this.$message.success('新建账号成功');
                this.editzhDialogVisible = false
                this.getCountList(this.zhParams)
              }
            } else {
              this.$message.error(res.data.message);
            }
          })
        }
      },
      //修改密码
      changePwd(val) {
        this.changezhDialogVisible = true
        this.changeuid = val
      },
      changezhCommit() {
        console.log(this.changePwdstr === this.changePwdstr1)
        console.log(this.changeuid)
        if (this.changePwdstr == '') {
          this.$message.error('请输入新密码');
        } else if (this.changePwdstr1 == '') {
          this.$message.error('请输入确认新密码');
        } else if (this.changePwdstr.length < 6) {
          this.$message.error('密码最少为六位');
        } else if (this.changePwdstr1.length < 6) {
          this.$message.error('密码最少为六位');
        } else if (this.changePwdstr !== this.changePwdstr1) {
          this.$message.error('新密码与确认新密码不一致');
        } else {
          initPassword({userId: this.changeuid, password: this.changePwdstr}).then(res => {
            console.log(res.status)
            console.log(res.data.success)
            if (res.status === 200 && res.data.success) {
              this.$message.success(res.data.message);
              this.changezhDialogVisible = false
            } else {
              this.$message.error(res.data.message);
            }
          })
        }
      },
      //删除账号
      deletZh(id) {
        this.$confirm('此操作将永久删除该账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteUser({"userId": id}).then(res => {
            if (res.status === 200 && res.data.success) {
              if (res.data.result.total === 0) {
                this.$Notice.open({
                  title: '查无数据'
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getCountList(this.zhParams)
              }
            } else {
              this.$message.error(res.data.message);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
    }
  }
</script>

<style scoped>
  .title-span {
    font-size: 16px;
  }

  .title_div {
    margin: 20px 30px;
  }

  .title-select {
    margin: 0 20px;
    width: 200px;
  }

  .title-date1 {
    margin-left: 20px;
    width: 180px;
  }

  .title-date2 {
    width: 180px;
  }

  .creat-button {
    margin: 20px 80px;
  }

  .mm-tb {
    width: 90%;
    margin-left: 50px;
  }

  .mm-page {
    margin: 30px 60px;
  }

  .dialog-div {
    margin: 20px 50px;
  }

  .creat_box {
    padding-left: 280px;
    padding-top: 40px;
  }

  .label_class {
    display: inline-block;
    width: 70px;
    color: #101d37;
  }

  .creat_div {
    margin-bottom: 25px;
  }

  .text_class {
    width: 418px;
    height: 192px;
    border-radius: 4px;
    border: solid 1px #dcdee2;
    padding: 7px 4px;
    vertical-align: text-top;
  }

  textarea::-webkit-input-placeholder {
    color: #c5c5c5;
  }

  textarea:-moz-placeholder {
    color: #c5c5c5;
  }

  textarea:-ms-input-placeholder {
    color: #c5c5c5;
  }

  .left_div {
    display: inline-block;
    width: calc(100% - 70px);
    vertical-align: text-top;

  }

  .left_div span {
    vertical-align: middle;
  }

  .quare {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 2px;
    border: solid 1px #d9d9d9;
    margin-right: 20px;
    cursor: pointer;
  }

  .quare img {
    width: 100%;
  }

  .hidden {
    display: none;
  }

  .submit {
    margin-top: 50px;
    margin-left: 30px;
    margin-bottom: 30px;
  }
  .orderMain {
    padding: 30px;
  }

</style>

